export const PATERNITY_EXAM_CODES = ['PATMATER', 'PAT', 'PATDUO', 'PATRECONS']

/**
 * Verifica se uma amostra é de paternidade.
 * Suporta ambas as origens AOL (paternity_relationship) e LIS (exams[].code).
 * @param {Object} sample
 * @returns {boolean}
 */
export function isSamplePaternity(sample) {
  if (sample.paternity_relationship) return true
  return (
    sample.exams?.some(exam => PATERNITY_EXAM_CODES.includes(exam.code?.toUpperCase())) ??
    false
  )
}

const getMnemonicParts = (sample) => {
  const label = sample?.batch_label
  if (!label || typeof label !== 'string') return []
  return label.split('.')
}

export const compareDestinationByMnemonic = (sampleA, sampleB) => {
  const partsA = getMnemonicParts(sampleA)
  const partsB = getMnemonicParts(sampleB)
  return partsA[0] !== undefined && partsA[0] === partsB[0]
}

export const comparePackagingByMnemonic = (sampleA, sampleB) => {
  const partsA = getMnemonicParts(sampleA)
  const partsB = getMnemonicParts(sampleB)
  return partsA[0] !== undefined && partsA[0] === partsB[0]
}

export const isSampleUrgent = (sample) => {
  return sample?.exams?.some(exam => exam?.urgent === true) ?? false
}
